// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nz-1";
export var messageSideRight = "_nz-2";
export var orderLookupBubbleContainer = "_nz-0";
export var submitButton = "_nz-3";